const map = {
	"./level0.json": [
		4214,
		[
			214
		]
	],
	"./level1.json": [
		2017,
		[
			17
		]
	],
	"./level2.json": [
		3972,
		[
			972
		]
	],
	"./level3.json": [
		2007,
		[
			7
		]
	],
	"./level4.json": [
		2714,
		[
			714
		]
	],
	"./level5.json": [
		5797,
		[
			797
		]
	],
	"./level6.json": [
		1432,
		[
			432
		]
	],
	"./level7.json": [
		9179,
		[
			179
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3253;
module.exports = webpackAsyncContext;